import styled from 'styled-components';
import { List } from '@alefeducation/ui-elements-library-core';
import { tableOverflow } from '../styles/Common';

export const StyledOrgContainer = styled(List)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({ theme: { space } }: any) => `${space[24]}px`};
`;

export const StyledTableBody = styled.div`
  height: 100%;
  overflow-y: auto;

  ${tableOverflow};
`;

export const StyledAddOrgButtonContainer = styled.div`
  justify-content: flex-end;
`;
